import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RecommendationPageUI from './RecommendationPageUI.js'

class RecommendationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loan: null,
      errorList: null,
      loanFeasibility: null,
      feasibilityItemList: [],
      failed: 0,
      total: 0,
      failedSmallLoan: 0,
      totalSmallLoan: 0,
      //
      keyFinancials: null,
      keyFinancialsList: []
    }
  }

  render() {
    return (
      <RecommendationPageUI
        context={this.props.context}
        loan={this.state.loan}
        account={this.state.account}
        errorList={this.state.errorList}
        loanFeasibility={this.state.loanFeasibility}
        feasibilityItemList={this.state.feasibilityItemList}
        failed={this.state.failed}
        total={this.state.total}
        failedSmallLoan={this.state.failedSmallLoan}
        totalSmallLoan={this.state.totalSmallLoan}
        keyFinancials={this.state.keyFinancials}
        keyFinancialsList={this.state.keyFinancialsList}
        transformedList={this.state.transformedList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getLoanFeasibility(context)
    this.getKeyFinancials(context)
  }

  getLoanFeasibility(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/feasibility`,
      cacheKey: CacheKeys.LoanFeasibility(this.props.match.params.loanId),
      callback: this.getLoanFeasibilityCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanFeasibilityCallback = (response) => {
    let failed = 0, total = 0, failedSmallLoan = 0, totalSmallLoan = 0
    let feasibility = response.loanFeasibility
    //
    for (var item of response.feasibilityItemList) {
      if (item.flavor === 'classic') {
        item.priority && total++
        !item.pass && item.priority && failed++
      }
      if (item.flavor === 'small') {
        totalSmallLoan++
        !item.pass && failedSmallLoan++
      }
    }

    this.setState({
      loanFeasibility: response, errorList: response.errorList,
      feasibilityItemList: response.feasibilityItemList,
      failed: failed, total: total, failedSmallLoan: failedSmallLoan, totalSmallLoan: totalSmallLoan
    })
  }

  getKeyFinancials(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/keyFinancials`,
      cacheKey: CacheKeys.KeyFinancials(this.props.match.params.loanId),
      callback: this.getKeyFinancialsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getKeyFinancialsCallback = (response) => {
    let reversedList = response.keyFinancialsList.reduce((acc, item) => [item].concat(acc), [])
    let transformedData = []
    reversedList.forEach(item =>
      item.itemList.forEach(entry => {
        if (!transformedData[entry.lable]) {
          transformedData[entry.lable] = { lable: entry.lable, valueList: [] }
        }
        transformedData[entry.lable].valueList.push({ year: item.financialYear, value: entry.valueF4 })
      })
    )
    this.setState({
      errorList: response.errorList, keyFinancials: response,
      keyFinancialsList: reversedList, transformedList: Object.values(transformedData),
    })
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.LoanFeasibility(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.KeyFinancials(this.props.match.params.loanId))
    if (noBusy === 'noBusy') {
      this.getLoanFeasibility(this.props.context)
      this.getKeyFinancials(context)
    }
    else
      this.setState({ loanFeasibility: null, keyFinancialsList: null },
        () => {
          this.getLoanFeasibility(this.props.context)
          this.getKeyFinancials(context)
        }
      )
  }
}

export default withRouter(RecommendationPageSF)
